export const defaultMemberEmailCheckerFormData = {
    email: ''
};
//# sourceMappingURL=data.js.map